// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"37661463","977":"1ae159f8"}[chunkId] + ".chunk.js";
};